import { ITimeTrackerDeleteAction } from './types';
import { AT_DELETE } from './constants';

export const timeTrackerDeleteAction = (): ITimeTrackerDeleteAction => ({
    type: AT_DELETE
});
